module.exports = __webpack_public_path__ + "static/media/yt.2d81e01a.png";